// extracted by mini-css-extract-plugin
export default {"numbersConstainer":"SlidesNumbers_numbersConstainer__K5AJc","numbers":"SlidesNumbers_numbers__6KWV1","active":"SlidesNumbers_active__jU6bA"};